const { gql } = require('@apollo/client');

const deps = ['Collection', 'Region'];

const factory = function (Collection, Region) {
  class RegionCollection extends Collection {
    $init() {
      super.$init();
      return this.$fetch();
    }

    $fetch() {
      // Regions are now nested inside countries in bench-backend
      // Fetch countries and extract/flatten the regions
      const query = gql`
        query CountriesForRegions {
          countries {
            code
            regions {
              countryCode
              code
              name
              taxPercent
            }
          }
        }
      `;
      const fetchPolicy = 'no-cache';
      return this.$graphqlClient
        .queryV2({ query, fetchPolicy })
        .then(res => {
          // Flatten regions from all countries
          const regions = res.data.countries.flatMap(country =>
            (country.regions || []).map(region => ({
              ...region,
              // Map 'code' to 'regionCode' for backwards compatibility
              regionCode: region.code,
            })),
          );
          this.$set(regions, { reset: true });
          return this.$cache();
        })
        .catch(() => {});
    }

    // Helper to get regions for a specific country
    getByCountryCode(countryCode) {
      return this.data.filter(region => region.countryCode === countryCode);
    }
  }

  RegionCollection.prototype.$resource = 'region';
  RegionCollection.prototype.$id = 'single';
  RegionCollection.prototype.$type = Region;

  return RegionCollection;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/model/region').name];

module.exports = angular
  .module('bench.data.collection.region', moduleDeps)
  .factory('RegionCollection', factory);
